import { MakeProtectedApiCall } from "../../../Services/api";

const baseUrl = process.env.REACT_APP_BASE_URL;

const getHeadersWithAuth = () => {
  return {
    "authorization": `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
    "content-type": "application/json"
  }
}

export const GET_BOOKING_BY_ID = (bookingId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "IS_BOOKING_INFO_LOADING", data: true });
      const url = `${baseUrl}/mall/vouchers/booking/${bookingId}`;
      const res = await MakeProtectedApiCall(
        url,
        "GET",
        getHeadersWithAuth(),
      );
      if (res?.status === 200) {
        dispatch({ type: "GET_BOOKING_BY_ID", data: res?.data })
        return { success: true, data: res?.data };
      }
      return { success: false };
    } catch (error) {
      console.log(error.response.data.replace(/\\/g, ""));
    } finally {
      dispatch({ type: "IS_BOOKING_INFO_LOADING", data: false });
    }
  }
}

export const GET_ALL_BOOKINGS = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: "IS_ALL_BOOKINGS_LOADING", data: true });
      const url = `${baseUrl}/mall/vouchers/bookings`;
      const res = await MakeProtectedApiCall(
        url,
        "GET",
        getHeadersWithAuth(),
      );
      if (res?.status === 200) {
        dispatch({ type: "GET_ALL_BOOKINGS", data: res?.data })
        return { success: true, data: res?.data };
      }
      return { success: false };
    } catch (error) {
      console.log(error.response.data.replace(/\\/g, ""));
    } finally {
      dispatch({ type: "IS_ALL_BOOKINGS_LOADING", data: false });
    }
  }
}